











































































import { Component } from 'vue-property-decorator';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import { paymentService } from '@/shared';
import { IPaymentDialog } from '@/models/paymentDialog';

@Component({
  components: {
    CenposPayment: () => import('@/components/common/cenpos.payment.vue'),
    SquarePayment: () => import('@/components/common/square.payment.vue'),
    CloverPayment: () => import('@/components/common/clover.payment.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue')
  },
})
export default class DepositLogPaymentPage extends Base {

  public paymentDialog: boolean = false;
  public transactionHeaderId: string = '';
  public detailId: string = '';
  public loading: boolean = false;
  public requestProgress: boolean = false;
  public storeDepositLog: any = {};

  public cenposDialog: boolean = false;
  public squareDialog: boolean = false;
  public isCloverDialog: boolean = false;

  public cenposStatus: boolean = false;
  public currentUrl: string = '';
  public storeName: string = '';
  public email: string = '';
  public zipCode: string = '';
  public city: string = '';
  public state: string = '';
  public address: string = '';
  public customerCode: string = '';

  public provider: string = '';
  public depositLogId: number = 0;
  public storeId: number = 0;
  public amountToBePaid: number = 0;
  public isCenposConfigured: boolean = false;
  public isSquareConfigured: boolean = false;
  public isCloverConfigured: boolean = false;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public loggedInUserEmail: string = '';
  public loggedInUserId: string = '';
  public amountWithServiceCharge: string = '';
  public isOverrideCCFeeApplied: boolean = true;
  public bypassReason: string = '';
  public firstName: string = '';
  public lastName: string = '';

  public mounted(): void {

    this.$watch("amountToBePaid", (newVal) => {
      this.paymentOptions.amount = Number(newVal);
    });

    this.$watch("depositLogId", (newVal) => {
      this.paymentOptions.recordKey = newVal.toString();
    });

    this.$watch("transactionHeaderId", (newVal) => {
      this.paymentOptions.transactionHeaderId = newVal;
    });

    this.$watch("detailId", (newVal) => {
      this.paymentOptions.lastPaymentDetailId = newVal;
    });

    this.$watch("customerCode", (newVal) => {
      this.paymentOptions.customerKey = newVal;
    });

    this.$watch("address", (newVal) => {
      this.paymentOptions.address = newVal;
    });

    this.$watch("city", (newVal) => {
      this.paymentOptions.city = newVal;
    });

    this.$watch("state", (newVal) => {
      this.paymentOptions.state = newVal;
    });

    this.$watch("zipCode", (newVal) => {
      this.paymentOptions.zipcode = newVal;
    });

    this.$watch("email", (newVal) => {
      this.paymentOptions.customerEmail = newVal;
    });

    this.$watch("amountWithServiceCharge", (newVal) => {
      this.paymentOptions.amountWithServiceCharges = newVal;
    });

    this.$watch("bypassReason", (newVal) => {
      this.paymentOptions.bypassReason = newVal;
    });

    this.$watch("isOverrideCCFeeApplied", (newVal) => {
      this.paymentOptions.isOverrideCCFeeApplied = newVal;
    });

    this.$watch("storeId", (newVal) => {
      this.paymentOptions.storeId = newVal;
    });
    this.$watch("enterpriseId", (newVal) => {
      this.paymentOptions.enterpriseId = newVal;
    });
    this.$watch("tenantId", (newVal) => {
      this.paymentOptions.tenantId = newVal;
    });
    this.$watch("firstName", (newVal) => {
      this.paymentOptions.firstName = newVal;
    });
    this.$watch("lastName", (newVal) => {
      this.paymentOptions.lastName = newVal;
    });
    this.transactionHeaderId = this.$route.params.txid;
    this.detailId = this.$route.params.detailid;
    this.currentUrl = window.location.href;
    if (this.transactionHeaderId && this.detailId) {
      this.getDepositLog(this.transactionHeaderId, this.detailId);
    } else {
      this.showAlert(
        false,
        this.$t('depositLogPayment.alertTransactionIdEmpty')
      );
    }

  }

  public async getDepositLog(
    transactionHeaderId: string,
    txDetailId: string
  ): Promise<void> {
    try {
      this.loading = true;
      const depositDetail = await paymentService.getDepositDetail(
        transactionHeaderId,
        txDetailId
      );

      this.tenantId = depositDetail.depositLog.tenantId;
      this.enterpriseId = depositDetail.depositLog.enterpriseId;
      this.loggedInUserEmail = this.userSession.email;
      this.loggedInUserId = this.userSession.sessionUserId;

      this.storeDepositLog = depositDetail;

      this.storeName = depositDetail.storeName;
      this.depositLogId = depositDetail.depositLog.id;
      this.storeId = depositDetail.depositLog.storeId;
      this.amountToBePaid = depositDetail.depositLog.amount;
      this.email = depositDetail.depositLog.depositLogJson.email;
      this.zipCode = depositDetail.depositLog.depositLogJson.zipCode;
      this.city = depositDetail.depositLog.depositLogJson.city;
      this.state = depositDetail.depositLog.depositLogJson.state;
      this.address = depositDetail.depositLog.depositLogJson.address;
      this.customerCode = depositDetail.depositLog.depositLogJson.customerCode;

      this.provider = depositDetail.provider;
      this.isCenposConfigured = depositDetail.isCenposConfigured;
      this.isSquareConfigured = depositDetail.isSquareConfigured;
      this.isCloverConfigured = depositDetail.isCloverConfigured;
      this.amountWithServiceCharge = depositDetail.amountWithServiceCharges;
      this.isOverrideCCFeeApplied = depositDetail.isOverrideCCFeeApplied;
      this.firstName = depositDetail.depositLog ? depositDetail.depositLog.firstName : '';
      this.lastName = depositDetail.depositLog ? depositDetail.depositLog.lastName : '';
      this.bypassReason = depositDetail.byPassReason;
      if (this.storeDepositLog.status === 'Approved') {
        this.showAlert(true, this.$t('depositLogPayment.alertPaymentApproved'));
      } else if (this.storeDepositLog.paymentDetailStatus === 'InProcess') {
        this.showAlert(true, this.$t('Payment is in process, Please check the final status in Payment report.'));
      }
    } finally {
      this.loading = false;
    }
  }

  public async pay(): Promise<void> {
    try {
      if (this.provider == 'Vantiv') {
        this.requestProgress = true;
        const depositLog = await paymentService.depositLogPay(
          this.transactionHeaderId,
          this.detailId
        );
        window.location.href = depositLog.paymentUrl;
      } else if (this.provider == 'Cenpos') {
        if (this.isCenposConfigured) {
          const validateMessage = this.validateCenpos();
          if (validateMessage == '') {
            this.paymentDialog = true;
            this.$root.$emit('validatePaymentProvider');
          } else {
            const message =
              'Can not Make the payment because, Customer' +
              validateMessage +
              ' are Empty.';
            this.showAlert(false, message);
          }
        } else {
          this.showAlert(
            false,
            'Cenpos Payment not configured, please contact admin.'
          );
        }
      }
      else {
        this.paymentDialog = true;
        this.$root.$emit('validatePaymentProvider');
      }
    } finally {
      this.requestProgress = false;
    }
  }

  public updateCenposDialog(cenposDialogVaue) {
    this.cenposDialog = cenposDialogVaue;
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }

  public validateCenpos(): string {
    let message = '';
    if (this.city == undefined || this.city == '') {
      message += ' City';
    }

    if (this.state == undefined || this.state == '') {
      message += ' State';
    }

    if (this.address == undefined && this.address == '') {
      message += ' Address';
    }

    return message;
  }

  public paymentOptions: IPaymentDialog = {
    id: "DepositLogPaymentAnonymous",
    url: window.location.href,
    amount: Number(this.amountToBePaid),
    recordKey: this.depositLogId.toString(),
    recordIdentifier: "DepositLog",
    type: "0",
    transactionHeaderId: this.transactionHeaderId,
    lastPaymentDetailId: this.detailId,
    customerKey: this.customerCode,
    address: this.address,
    city: this.city,
    state: this.state,
    zipcode: this.zipCode,
    customerEmail: this.email,
    amountWithServiceCharges: this.amountWithServiceCharge,
    showTextField: true,
    bypassReason: this.bypassReason,
    isOverrideCCFeeApplied: this.isOverrideCCFeeApplied,
    storeId: this.storeId,
    tenantId: this.tenantId,
    enterpriseId: this.enterpriseId,
    firstName: this.firstName,
    lastName: this.lastName
  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }
}
